import { render, staticRenderFns } from "./monthlySupplyListSec.vue?vue&type=template&id=24591283&scoped=true"
import script from "./monthlySupplyListSec.vue?vue&type=script&lang=js"
export * from "./monthlySupplyListSec.vue?vue&type=script&lang=js"
import style0 from "./monthlySupplyListSec.vue?vue&type=style&index=0&id=24591283&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24591283",
  null
  
)

export default component.exports